<script setup lang="ts">
/**
 * Plain right-aligned integer in a tabular font, or a muted dash when the
 * value is absent (e.g. a subscription with no visit cap).
 */
defineProps<{
  value?: number | null
  /** Max width of the cell (CSS value). Set by DynamicTable from column config. */
  maxWidth?: string
}>()
</script>

<template>
  <td class="count-cell font-tufte">
    <span v-if="value != null">{{ value }}</span>
    <span v-else class="count-cell__none">—</span>
  </td>
</template>

<style scoped>
.count-cell {
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.count-cell__none {
  color: var(--color-tufte-muted);
  opacity: 0.6;
}
</style>
